import './app/publicPath'

const Vue = window.Vue

Vue.component('PropertyWidget', () => import('./app/propertyWidget.vue'))
